import React, { useEffect, useRef, useState } from 'react'
import NetaqInput from './NetaqInput';
import UploadFile from './UploadFile';
import SignaturePad from "react-signature-canvas";
import axiosInstance from '../axios/axios';
import EahsForm from './EahsForm';
import { eformCheckBox, eformInput, eformTerms, saveBtnInProfile } from '../common/cssclasses';
import NewActionButton from './ActionButtons/NewActionButton';
import CustomSecondPopUp from './CustomSecondPopUp';
import OwnerPermisions from './OwnerPermisions';
import SimpleUpload from "./SimpleFileUpload";
import PhoneDropDownInput from './shared/PhoneDropDownInput';
import { useTranslate } from './TranslationText';
import { getProfile, updateAccount, verfyEmail } from '../pages/sharedAPI/userApis';
import LoginUaePassOTPForm from './LoginUaePassOTPForm';
import { getCitiesListbyID, getRegionListbyID } from '../pages/sharedAPI/lookUpApis';
import CustomPopUp from './CustomPopUp';
const isTestApp = process.env.REACT_APP_IS_TEST == "true";

export default function AccountSetting({ toast, reloadProfile, setActiveTab, handelChangePassword, setOldPassword, showErrorConfirmPassword, setConfirmPassword, setConfirmNewPassword }) {
    const formSchemaData = {
        fullName: '',
        fullNameAr: '',
        email: '',
        mobileNo: '',
        secondEmail: '',
        phone: '',
        secondMobileNo: '',
        invalidMobileNo: true,
        invalidPhone: true,
        invalidSecondMobileNo: true,
        signiture: '',
        bankName: '',
        bneficiaryName: '',
        iban: '',
        bankAccountNumber: '',
        swiftCode: '',
        bankCountry: '',
        currencyId: '',
        hasTrn: null,
        trn: '',
        trcFile: '',
        isUaePass: false,
        profileImage: '',
        isStud: false,
        isAgent: false,
        isHandler: false,
        trcFileName: '',
        secondEmail: '',
        signature: '',
        handlerFile: '',
        bankCountryId: ''
    }

    const isLoggedInUser = localStorage.getItem('currentSubAccountId') === localStorage.getItem('EAHSUserID');

    const { translate } = useTranslate();
    const [formData, setFormData] = useState(formSchemaData);
    const [isHandler, setIsHandler] = useState(null);

    const [invalidIban, setInvalidIBAN] = useState(false);
    const [curenciesOptions, setCurenciesOptions] = useState([]);
    const [nationalityOptions, setNationalityOptions] = useState([]);
    const [citiesList, setCitiesList] = useState([]);
    const [regionList, setRegionList] = useState([]);
    const [birthDate, setBirthDate] = useState([]);
    const [imageURL, setImageURL] = useState();
    const [otp, setOtp] = useState();
    const signatureCanvas = useRef(null);
    const onSaveSignature = (onCloseSignaturePad) => {
        if (!signatureCanvas.current?.isEmpty()) {
            const imageData = signatureCanvas.current
                .getTrimmedCanvas()
                .toDataURL("image/png");
            setImageURL(imageData);
        }
    };

    const onClearSignature = () => signatureCanvas?.current?.clear();

    async function getcurrencyList() {
        try {
            const currencylist = await axiosInstance.get('/lookup/getcurrencies');
            const formattedData = currencylist?.data?.result?.map((item) => ({
                ...item,
                label: item.text
            }))

            setCurenciesOptions(formattedData ?? []);
            if (formData != false) {
                const defaultCurrency = formattedData?.find(item => item.value == formData?.currencyId);
                if (defaultCurrency) {
                    setFormData(prev => ({
                        ...prev, currencyId: defaultCurrency?.value
                    }))
                }
            }
        } catch (error) {
            console.error('error in currency list')
        }
    }

    async function getNationalityList() {
        try {
            const nationalityList = await axiosInstance.get('/nationality')
            const formattedData = await nationalityList.data.result.map((item) => ({
                text: item.name,
                label: item.name,
                value: item.id,
            }));
            setNationalityOptions(formattedData);
            if (formData != false) {
                const defaultCountry = formattedData?.find(item => item.value == formData?.bankCountryId);
                if (defaultCountry) {
                    setFormData(prev => ({
                        ...prev, bankCountryId: defaultCountry?.value
                    }))
                }
            }
        } catch (error) {
            console.error('eror in getting countries')
        }
    }


    useEffect(() => {
        getNationalityList();
        getcurrencyList();
        getProfile().then(res => {
            setFormData(res?.result);
            if (!!res?.result?.countryId)
                getCites(res?.result?.countryId)
            if (!!res?.result?.regionId)
                getRegions(res?.result?.cityId)
            if (!!res?.result?.profileImage) {
                setProfileImageFile([{
                    documentFile: res?.result?.profileImage,
                    name: translate('web.profileImage', 'Profile Image'),
                    file: res?.result?.profileImage,
                }])
            }
            if (!!res?.result?.trcFile) {
                setTrc([{
                    documentFile: res?.result?.trcFile,
                    name: res?.result?.trcFileName,
                    file: res?.result?.trcFile,
                }])
            }
            if (!!res?.result?.signature) {
                setImageURL(res?.result?.signature)
            }
            setIsHandler(res?.result?.isHandler)

        })

    }, []);



    useEffect(() => {
        if (((formData?.iban?.length < 14 || formData?.iban?.length > 35) && (formData?.iban.length > 0)) ?? false) {
            setInvalidIBAN(true);
        } else {
            setInvalidIBAN(false);
        }
    }, [formData?.iban]);


    const isBasicAccount = formData?.accountType == "BasicAccount" ?? false;

    const disableSaveBasic = !formData?.email || !formData?.phone;

    const disableSave = !formData?.email || !formData?.phone || !formData?.secondEmail || !formData?.mobileNo || !formData?.ownerPhoneNo;

    function isServerFile(files = []) {
        if (files?.length > 0) {
            try {
                if (files[0]?.file?.startsWith('http')) {
                    return true
                } else {
                    return false
                }
            } catch (error) {
                return false
            }
        } else {
            return false;
        }
    }

    const [idFile, setIdFile] = useState([]);
    const [profileImageFile, setProfileImageFile] = useState([]);
    const [handlerCertificate, setHandlerCertificate] = useState([]);
    const [trc, setTrc] = useState([]);
    const [showOtpBox, setShowOtpBox] = useState(false);
    const [signature, setSigniture] = useState('');


    const handleUpload = (e, setData, isSigniture = false) => {
        if (e.target.files && e.target.files.length > 0) {
            let checkFileSize = true;
            const fileListHook = [];

            for (let fileIndex = 0; fileIndex < e.target.files.length; fileIndex++) {
                if (e.target.files[fileIndex].size > 10 * 1024 * 1024) {
                    checkFileSize = false;
                    toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
                } else {
                    // Check allowed file types
                    const file = e.target.files[fileIndex];
                    const allowedMimeTypes = ['image/', 'application/pdf'];

                    if (!allowedMimeTypes.some(type => file.type.startsWith(type))) {
                        toast.error(translate("web.invalidFileType", "Only images and PDFs allowed."));
                        continue; // Skip to the next file if type is not allowed
                    }
                    if (!!isSigniture) {
                        var reader = new FileReader();
                        reader.readAsDataURL(e.target.files[0]);
                        reader.onload = function () {
                            setImageURL(reader.result);
                        };
                    } else {
                        fileListHook.push({
                            documentFile: URL.createObjectURL(e.target.files[fileIndex]),
                            name: e.target.files[fileIndex].name,
                            file: e.target.files[fileIndex],
                        });
                    }

                }
            }
            setData(fileListHook);
        }
    };


    const change = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }))
    }

    const updateBankDetails = (e) => {
        e.preventDefault();
        if (invalidIban) {
            toast.error(translate('web.invalidIban', 'Invalid IBAN'))
            return;
        }
        let obj = {
            bankName: formData?.bankName,
            swiftCode: formData?.swiftCode,
            bneficiaryName: formData?.bneficiaryName,
            iban: formData?.iban,
            bankAccountNumber: formData?.bankAccountNumber,
            bankCountryId: formData?.bankCountryId,
            currencyId: formData?.currencyId,
        }
        updateAccount(obj).then(res => {
            if (res?.data?.responseCode == "200") {
                toast.success(translate('web.dataSavedSuccessfully', 'Data Saved Successfully'));
            } else {
                toast.error(translate('web.errorWhileSaving', 'Error While Saving'));
            }
        })
    }
    const updateBasicDetails = (e) => {
        e.preventDefault();
        if (!formData?.phone || formData?.invalidPhone) {
            toast.error(translate('web.invalidPhone', 'Invalid Phone'))
            return;
        }
        if (!formData?.mobileNo || formData?.invalidMobileNo) {
            toast.error(translate('web.invalidMobileNo', 'Invalid Mobile No'))
            return;
        }
        if (!formData?.secondMobileNo || formData?.invalidSecondMobileNo) {
            toast.error(translate('web.invalidSecondMobileNo', 'Invalid Second MobileNo'))
            return;
        }
      
            if (!formData?.genderValue) {
                toast.error(translate('web.gender', 'gender') + " " + translate('web.isRequired', 'is Required'))
                return;
            }
            if (!formData?.nationalityId) {
                toast.error(translate('web.nationality', 'nationality') + " " + translate('web.isRequired', 'is Required'))
                return;
            }
            if (!formData?.countryId) {
                toast.error(translate('web.country', 'countryId') + " " + translate('web.isRequired', 'is Required'))
                return;
            }
            if (!formData?.cityId) {
                toast.error(translate('web.emirate', 'emirate') + " / " + translate('web.city', 'city') + translate('web.isRequired', 'is Required'))
                return;
            }
            if (!formData?.address) {
                toast.error(translate('web.address', 'address') + " " + translate('web.isRequired', 'is Required'))
                return;
            }
            if (!formData?.isIdPassportUploaded && idFile.length < 1) {
                toast.error(translate('web.idFile', 'idFile') + " " + translate('web.isRequired', 'is Required'))
                return;
            }
        

        if (isHandler != true) {
            if (formData?.isHandler && handlerCertificate.length <= 0) {
                toast.error(translate('web.pleaseUploadHandlerCertificate', 'Please Upload Handler Certificate'))
                return;
            }
        }

        let obj = {
            email: formData?.email,
            phoneNo: formData?.phone,
            secondEmail: formData?.secondEmail,
            mobileNo: formData?.mobileNo,
            secondMobileNo: formData?.secondMobileNo,
            signature: imageURL,
            profileImageFile: profileImageFile?.at(-1)?.file,
            nationalIdFile: idFile?.at(-1)?.file,
            handlerFile: handlerCertificate?.at(-1)?.file,
                gender: formData?.genderValue,
                nationalityId: formData?.nationalityId,
                countryId: formData?.countryId,
                cityId: formData?.cityId,
                regionId: formData?.regionId,
                address: formData?.address,
                birthDate: birthDate
        }
        updateAccount(obj).then((res) => {
            if (res?.data?.responseCode == "202") {
                toast.warn(translate('web.anOtpHasBeenSentToYourEmail', 'An Otp Has Been Sent To Your Email'));
                setShowOtpBox(true)
            }
            if (res?.data?.responseCode == "201") {
                toast.error(translate('web.emailIsAlreadyWithAnotherUser', 'Email Is Already With Another User'));
            }
            if (res?.data?.responseCode == "200") {
                toast.success(translate('web.dataSavedSuccessfully', 'Data Saved Successfully'));
            }

        })

    }

    const updateTrn = (e) => {
        e.preventDefault();
        if (!!formData?.hasTrn) {
            if (trc?.length <= 0) {
                toast.error(translate('web.pleaseAddTrcFile', 'Please Add TRC File'))
                return;
            }
        }
        let obj = {
            trcFile: trc?.at(-1)?.file,
            trn: formData?.trn,
            hasTrn: formData?.hasTrn
        }
        updateAccount(obj).then(res => {
            if (res?.data?.responseCode == "200") {
                toast.success(translate('web.dataSavedSuccessfully', 'Data Saved Successfully'));
            } else {
                toast.error(translate('web.errorWhileSaving', 'Error While Saving'));
            }
        })
    }

    const handleOTPSubmit = (e) => {
        e.preventDefault();
        verfyEmail(otp).then((res) => {
            if (res?.data?.status) {
                if (res?.data?.status?.responseCode == "200") {
                    toast.success(translate('web.verifiedSuccessfully', 'Verified Successfully'))
                    setShowOtpBox(false);
                } else {
                    toast.error(translate(`web.${res?.data?.status?.detailedResponseCode}`, `${res?.data?.status?.detailedResponseCode}`))
                    setShowOtpBox(false);
                }
            }
        })
    }

    function getCites(id) {
        getCitiesListbyID(id).then(res => setCitiesList(res))
    }
    function getRegions(id) {

        getRegionListbyID(id).then(res => setRegionList(res))
    }

    const [taosted, setToasted] = useState(false);

    useEffect(() => {
        if (!!formData?.fullName) {
            if (!formData?.isProfileCompleted && !taosted) {
                toast.error(translate('web.completeProfileMsg', 'Your profile must be completed before you can proceed. Please update the required information to unlock full system access.'))
                setToasted(true)
            }
        }

    }, [formData])



    return <>
        <div className={(!!formData?.isProfileCompleted) ? "col-lg-9 col-md-8 col-sm-12 rtl" : "col-12 rtl"}>

            <EahsForm isNoMargin className={'mb-main'} isform onSubmit={updateBasicDetails} title={translate("web.userInfo", "user Info")}>
                <div className={eformInput}>
                    <NetaqInput
                        type={"text"}
                        name={"fullName"}
                        placeholder={translate("web.englishName", "English Name")}
                        label={translate("web.englishName", "English Name")}
                        value={formData?.fullName}
                        disabled={true}
                        onChange={change} />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type={"text"}
                        name={"fullNameAr"}
                        placeholder={translate("web.arabicName", "Arabic Name")}
                        label={translate("web.arabicName", "Arabic Name")}
                        value={formData?.fullNameAr}
                        disabled={true}
                        onChange={change} />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type={"email"}
                        name={"email"}
                        placeholder={translate("web.email", "Email")}
                        label={translate("web.email", "Email")}
                        value={formData?.email}
                        required
                        disabled={formData?.isUaePass}
                        onChange={change}
                    />
                </div>

                <div className={eformInput}>
                    <PhoneDropDownInput
                        name={"phone"}
                        placeholder={translate("web.phoneNo", "Mobile No")}
                        label={translate("web.phoneNo", "Mobile No")}
                        disabled={!!formData?.isUaePass}
                        required
                        value={formData?.phone}
                        onChange={(e, isValidNumber) => {
                            setFormData(prev => ({
                                ...prev,
                                phone: e,
                                invalidPhone: !isValidNumber
                            }));
                        }}
                    />
                </div>
                {!isBasicAccount && (
                    <>
                        <div className={eformInput}>
                            <NetaqInput
                                type={"email"}
                                name={"secondEmail"}
                                placeholder={translate(
                                    "web.secondEmail",
                                    "Second Email"
                                )}
                                label={translate("web.secondEmail", "Second Email")}
                                value={formData?.secondEmail}
                                onChange={change}
                                required />
                        </div>
                        <div className={eformInput}>
                            <PhoneDropDownInput
                                name={"mobileNo"}
                                placeholder={translate("web.mobileNo", "Mobile No")}
                                label={translate("web.mobileNo", "Mobile No")}
                                value={formData?.mobileNo}
                                required
                                onChange={(e, isValidNumber) => {
                                    setFormData(prev => ({
                                        ...prev,
                                        mobileNo: e,
                                        invalidMobileNo: !isValidNumber
                                    }));
                                }}
                            />
                        </div>
                        <div className={eformInput}>
                            <PhoneDropDownInput
                                name={"secondMobileNo"}
                                placeholder={translate(
                                    "web.secondMobileNo",
                                    "Second Mobile No"
                                )}
                                label={translate(
                                    "web.secondMobileNo",
                                    "Second Mobile No"
                                )}
                                value={formData?.secondMobileNo}
                                required
                                onChange={(e, isValidNumber) => {
                                    setFormData(prev => ({
                                        ...prev,
                                        secondMobileNo: e,
                                        invalidSecondMobileNo: !isValidNumber
                                    }));
                                }}
                            />
                        </div>
                        {<>
                            <div className={eformInput} >
                                <label className="capatalize_text">
                                    {translate('web.gender', 'Gender')}  <span className="color-eahsred">*</span>
                                </label>
                                <div className='d-flex'>
                                    <NetaqInput
                                        type={"radio2"}
                                        name={"gender"}
                                        placeholder={translate(
                                            "web.male",
                                            "Male"
                                        )}
                                        label={translate("web.male", "male")}
                                        checked={formData?.genderValue == 1}
                                        onChange={(evt) => setFormData(prev => ({
                                            ...prev,
                                            gender: 1,
                                            genderValue: 1
                                        }))}
                                    />
                                    <NetaqInput
                                        type={"radio2"}
                                        name={"gender"}
                                        placeholder={translate(
                                            "web.female",
                                            "Female"
                                        )}
                                        label={translate("web.female", "Female")}
                                        checked={formData?.genderValue == 2}
                                        value={formData?.genderValue}
                                        onChange={(evt) => setFormData(prev => ({
                                            ...prev,
                                            gender: 2,
                                            genderValue: 2
                                        }))}
                                    />
                                </div>
                            </div>
                            <div className={eformInput}>
                                <NetaqInput
                                    key={'nationality'}
                                    type={"select"}
                                    required
                                    label={translate("web.nationality", "Choose Nationality")}
                                    placeholder={translate("web.nationality", "Choose Nationality")}
                                    name={"nationalityId"}
                                    listSelect={nationalityOptions}
                                    value={nationalityOptions?.find(item => item.value == formData?.nationalityId)}
                                    onChange={(evt) => {
                                        setFormData(prev => ({
                                            ...prev,
                                            nationalityId: evt.value
                                        }));
                                    }}

                                />
                            </div>
                            <div className={eformInput}>
                                <NetaqInput
                                    key={'countryId'}
                                    type={"select"}
                                    required
                                    label={translate("web.country", "Choose country")}
                                    placeholder={translate("web.country", "Choose country")}
                                    name={"CountryId"}
                                    listSelect={nationalityOptions}
                                    value={nationalityOptions?.find(item => item.value == formData?.countryId)}
                                    onChange={(evt) => {
                                        setFormData(prev => ({
                                            ...prev,
                                            countryId: evt.value
                                        })); getCites(evt.value)
                                    }}

                                />
                            </div>
                            <div className={eformInput}>
                                <NetaqInput
                                    key={'cityId'}
                                    type={"select"}
                                    required
                                    label={formData?.countryId == "7b2a7859-1811-4475-1ccf-08dc12ef16d3" ? translate("web.chooseEmirate", "Choose Emirate") : translate("web.chooseCity", "Choose city")}
                                    placeholder={formData?.countryId == "7b2a7859-1811-4475-1ccf-08dc12ef16d3" ? translate("web.chooseEmirate", "Choose Emirate") : translate("web.chooseCity", "Choose city")}
                                    name={"cityId"}
                                    listSelect={citiesList}
                                    value={citiesList?.find(item => item.value == formData?.cityId)}
                                    onChange={(evt) => {
                                        setFormData(prev => ({
                                            ...prev,
                                            cityId: evt.value,
                                            regionId: null
                                        }));
                                        if (formData?.countryId == "7b2a7859-1811-4475-1ccf-08dc12ef16d3") {
                                            getRegions(evt?.value)
                                        }
                                    }}

                                />
                            </div>
                            {formData?.countryId == "7b2a7859-1811-4475-1ccf-08dc12ef16d3" && (regionList?.length > 0) && (
                                <>

                                    <div className={eformInput}>
                                        <NetaqInput
                                            type={"select"}
                                            label={translate("web.region", "Choose Region")}
                                            placeholder={translate("web.region", "Choose Region")}
                                            name={"regionId"}
                                            key={'region'}
                                            listSelect={regionList}
                                            value={regionList?.find(item => item.value == formData?.regionId) ?? null}
                                            onChange={(evt) => {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    regionId: evt.value
                                                }));
                                            }}
                                            required={false} />
                                    </div>
                                </>
                            )}
                            <div className={eformInput}>
                                <NetaqInput
                                    type={"text"}
                                    label={translate("web.address", "Address")}
                                    placeholder={translate("web.address", "Address")}
                                    name={"address"}
                                    value={formData?.address}
                                    required
                                    onChange={change} />
                            </div>
                            {formData?.isStud != true &&
                                <div className={eformInput}>
                                    <NetaqInput
                                        name={"birthDateString"}
                                        type={"normalDate"}
                                        label={translate('web.birthDate', "Birth Date")}
                                        placeholder={translate('web.birthDate', "Birth Date")}
                                        value={!!formData?.birthDateString ? formData?.birthDateString : birthDate}
                                        required
                                        disabled={!!formData?.birthDateString}
                                        onChange={(e) => setBirthDate(e.target.value)} />
                                </div>
                            }
                        </>}
                        <div className={eformInput} >
                            <label className="capatalize_text">
                                {translate('web.IdorPassport', 'National Id File')}
                                {!formData?.isProfileCompleted &&
                                    <span className="color-eahsred">*</span>
                                }
                            </label>
                            <SimpleUpload
                                accept="image/*,application/pdf"
                                isMulti={false}
                                isServer={false}
                                initialFiles={idFile}
                                onChange={(e) => handleUpload(e, setIdFile)}
                                key={'NATIONAL ID FILE'} />
                        </div>
                        <div className={eformInput} >
                            <label className="capatalize_text">
                                {translate('web.profileImage', 'Profile Image')}
                            </label>
                            <SimpleUpload
                                accept="image/*"
                                isMulti={false}
                                isServer={
                                    isServerFile(profileImageFile)
                                }
                                initialFiles={profileImageFile}
                                onChange={(e) => handleUpload(e, setProfileImageFile)}
                                key={'Profile Id'} />
                        </div>

                        <div className={eformTerms}>
                            <div className="row mx-0">
                                <div className={eformCheckBox}>
                                    <NetaqInput
                                        type={"checkbox"}
                                        label={translate(
                                            "web.iHaveHandlerCertificate",
                                            "I Have Handler Certificate"
                                        )}
                                        name="iHaveHandlerCertificate"
                                        disabled={formData?.isHandler == true}
                                        checked={isHandler}
                                        onChange={(e) => setIsHandler(e.target.checked)}
                                    />
                                </div>
                            </div>
                        </div>

                        {isHandler && (formData?.isHandler == false) && (
                            <div className={'col-lg-6 mb-1 col-md-6 col-sm-12  rtl form-group'} >
                                <label className="capatalize_text">
                                    {translate('web.handlerCertificate', 'Handler Certificate')}
                                    <span className="color-eahsred">*</span>
                                </label>
                                <SimpleUpload
                                    accept="image/*,application/pdf"
                                    isMulti={false}
                                    isServer={false}
                                    initialFiles={handlerCertificate}
                                    onChange={(e) => handleUpload(e, setHandlerCertificate)}
                                    key={'HANDLER CERTIFICATE'} />
                            </div>
                        )}
                    </>
                )}
                <div className={eformInput + " ms-auto"} >
                    <>
                        <label>{translate("web.signature", "Signature")}</label>
                        <div className='row'>
                            <CustomSecondPopUp
                                trigger={<div className="col-sm-5 col-12 mb-md-0 mb-sm-2 mb-2">
                                    <div className='btn btn-dark'>
                                        {translate(
                                            "web.openSigniturePad",
                                            "Open Signiture Pad"
                                        )}
                                    </div>
                                </div>}
                                onClear={onClearSignature}
                                onSave={onSaveSignature}
                            >
                                <SignaturePad
                                    ref={signatureCanvas}
                                    canvasProps={{
                                        className: "signatureCanvas",
                                    }} />
                            </CustomSecondPopUp>
                            <div className="col-sm-2 col-12 text-center d-flex justify-content-center align-items-center">
                                {translate("web.or", "OR")}
                            </div>
                            {<div className="col-sm-5 col-12 mb-md-0 mb-sm-2 mb-2 text-end">
                                <UploadFile
                                    text="Upload Singniture Photo"
                                    onChange={(e) => handleUpload(e, setSigniture, true)} />
                            </div>}
                        </div>
                        {!!imageURL &&

                            <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
                                <div className="text-center">
                                    {!!imageURL ||
                                        (!!formData &&
                                            !!formData.signature) ? (
                                        //(!!OwnerByIdData && !!OwnerByIdData.signature) ? (
                                        <img
                                            src={imageURL || formData.signature}
                                            //src={imageURL || OwnerByIdData.signature}
                                            alt={translate("web.signature", "Signature")}
                                            style={{
                                                width: "100%",
                                                maxWidth: 216,
                                                maxHeight: 216,
                                            }} />
                                    ) : null}
                                </div>
                            </div>
                        }
                    </>
                </div>

                <div>
                    <div className={saveBtnInProfile}>
                        <NewActionButton
                            isButton
                            text={translate("web.save", "Save")}
                            disabled={isBasicAccount ? disableSaveBasic : false} />
                    </div>
                </div>
            </EahsForm>

            <EahsForm isNoMargin title={translate("web.bankDetails", "Bank Details")} onSubmit={updateBankDetails} isform className="mb-main">
                <div className={eformInput}>
                    <NetaqInput
                        type={"text"}
                        name={"bankName"}
                        placeholder={translate("web.bankName", "Bank Name")}
                        label={translate("web.bankName", "Bank Name")}
                        value={formData?.bankName}
                        required
                        onChange={change} />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type={"text"}
                        name={"bneficiaryName"}
                        required
                        placeholder={translate("web.bneficiaryName", "Beneficiary Name")}
                        label={translate("web.bneficiaryName", "Bneficiary Name")}
                        value={formData?.bneficiaryName}
                        onChange={change} />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type={"text"}
                        label={translate("web.iban", "IBAN")}
                        placeholder={translate("web.iban", "Iban")}
                        name={"iban"}
                        required
                        value={formData?.iban}
                        key={"IBAN"}
                        onChange={change}
                    />
                    {invalidIban &&
                        <div className='text-danger text-center'>
                            {translate('web.invalidIban', 'Invalid IBAN')}
                        </div>
                    }
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type={"text"}
                        name={"bankAccountNumber"}
                        placeholder={translate("web.BankAccountNumber", "Bank Account Number")}
                        label={translate("web.BankAccountNumber", "Bank Account Number")}
                        value={formData?.bankAccountNumber}
                        required
                        onChange={change}
                    />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type={"text"}
                        name={"swiftCode"}
                        placeholder={translate("web.swiftCode", "SwiftCode")}
                        label={translate("web.swiftCode", "SwiftCode")}
                        value={formData?.swiftCode}
                        required
                        onChange={change} />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        key={'bankCountryId'}
                        type={"select"}
                        required
                        label={translate("web.bankCountry", "Bank Country")}
                        placeholder={translate("web.bankCountry", "Bank Country")}
                        name={"bankCountryId"}
                        listSelect={nationalityOptions}
                        value={nationalityOptions?.find(item => item.value == formData?.bankCountryId)}
                        onChange={(evt) => setFormData(prev => ({
                            ...prev,
                            bankCountryId: evt.value
                        }))}

                    />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        key={'currencyId'}
                        type={"select"}
                        label={translate("web.curency", "Curency")}
                        placeholder={translate("web.curency", "curency")}
                        name={"currencyId"}
                        required
                        listSelect={curenciesOptions}
                        value={curenciesOptions?.find(item => item.value == formData?.currencyId)}
                        onChange={(evt) => setFormData(prev => ({
                            ...prev,
                            currencyId: evt.value
                        }))}

                    />
                </div>

                <div className={saveBtnInProfile}>
                    <NewActionButton
                        isButton
                        text={translate("web.save", "Save")}
                        type="submit"
                        disabled={false} />

                </div>

            </EahsForm>
            <EahsForm isNoMargin title={translate("web.trnDetails", "TRN Details")} isform onSubmit={updateTrn} className="mb-main">
                <label className="capatalize_text">
                    {translate("web.registeredforVAT", "Are you registered for VAT with the Federal Tax Authority")}
                </label>
                <div className={eformInput}>
                    <NetaqInput
                        key={'no'}
                        type='radio'
                        name={'hasTrn'}
                        label={translate('web.no', 'No')}
                        onClick={() => {
                            setFormData(prev => ({
                                ...prev,
                                hasTrn: false
                            }))
                        }}
                        onChange={(e) => {
                            setFormData(prev => ({
                                ...prev,
                                hasTrn: false
                            }))
                        }}
                    />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        key={'yes'}
                        type='radio'
                        name={'hasTrn'}
                        label={translate('web.yes', 'Yes')}
                        checked={formData?.hasTrn == true ? true : null}
                        onClick={() => {
                            setFormData(prev => ({
                                ...prev,
                                hasTrn: true
                            }))
                        }}
                        onChange={(e) => {
                            setFormData(prev => ({
                                ...prev,
                                hasTrn: true
                            }))
                        }}
                    />
                </div>
                {!!formData?.hasTrn &&
                    <>
                        <div className={eformInput}>
                            <NetaqInput
                                type={"text"}
                                name={"trn"}
                                placeholder={translate("web.taxRegistrationNumber", "Tax Registration Number")}
                                label={translate("web.taxRegistrationNumber", "Tax Registration Number")}
                                value={formData?.trn}
                                required
                                onChange={change} />
                        </div>
                        <div className={eformInput}>
                            <label className="capatalize_text">
                                {translate("web.taxRegistrationCertificate", "Tax Registration Certificate")}
                                <span className="color-eahsred">*</span>
                            </label>
                            <SimpleUpload
                                accept="image/*,application/pdf"
                                isMulti={false}
                                isServer={!!formData?.trcFile}
                                initialFiles={trc}
                                onChange={(e) => handleUpload(e, setTrc)}
                                name={'TRCFile'}
                                key={'TRCFile'}
                            />
                        </div>
                    </>
                }


                <div className={saveBtnInProfile}>
                    <NewActionButton
                        isButton
                        text={translate("web.save", "Save")}
                        type="submit"
                        disabled={false} />

                </div>

            </EahsForm>

            {!!formData?.isUaePass === false && isLoggedInUser && (
                <EahsForm
                    isNoMargin
                    title={translate("web.changePassword", "Change Password")}
                    isform={true}
                    onSubmit={handelChangePassword}
                    className="mb-main"
                >
                    <div className={eformInput}>
                        <NetaqInput
                            type={"password"}
                            name={"oldpassword"}
                            placeholder={translate(
                                "web.oldPassword",
                                "Old Password"
                            )}
                            label={translate("web.oldPassword", "Old Password")}
                            onChange={(e) => setOldPassword(e.target.value)}
                            required={true} />
                    </div>
                    {showErrorConfirmPassword != "none" && (
                        <div
                            className={eformInput}
                        >
                            <span
                                className="text-danger"
                                style={{
                                    display: showErrorConfirmPassword,
                                    margin: "auto",
                                }}
                            >
                                {translate(
                                    "web.errorConfirmPassword",
                                    "Error in Confirm Password"
                                )}
                            </span>
                        </div>
                    )}
                    <div className={eformInput}>
                        <NetaqInput
                            type={"password"}
                            name={"newpassword"}
                            placeholder={translate(
                                "web.newPassword",
                                "New Password"
                            )}
                            label={translate("web.newPassword", "New Password")}
                            onChange={(e) => setConfirmNewPassword(e.target.value)}
                            required={true} />
                    </div>
                    <div className={eformInput}>
                        <NetaqInput
                            type={"password"}
                            name={"confirmpassword"}
                            placeholder={translate(
                                "web.confirmPassword",
                                "Confirm Password"
                            )}
                            label={translate(
                                "web.confirmPassword",
                                "Confirm Password"
                            )}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required={true} />
                    </div>
                    <div className='d-flex px-0'>
                        <div className={saveBtnInProfile}>
                            <NewActionButton
                                isButton
                                type="submit"
                                text={translate("web.save", "Save")}
                            />
                        </div>
                    </div>

                </EahsForm>
            )}
            {isLoggedInUser && <>
                <div className={eformCheckBox}>
                    <NetaqInput
                        type={"checkbox"}
                        label={translate(
                            "web.agentForOtherOwner",
                            "Agent For Other Owner"
                        )}
                        name="agentForOtherOwner"
                        checked={formData?.isAgent}
                        onChange={(e) => setFormData(prev => ({
                            ...prev,
                            isAgent: e.target.checked
                        }))}
                    />
                </div>
                {formData?.isAgent && (
                    <OwnerPermisions
                        toast={toast}
                        reloadProfile={reloadProfile}
                        setActiveTab={setActiveTab}
                    />
                )}
            </>}
        </div>
        {showOtpBox &&
            <>
                <LoginUaePassOTPForm showSuccessmessage={toast.success} showErrormessage={toast.error} isRegisterPage={true} email={formData?.email} setOTP={setOtp} onSubmit={handleOTPSubmit} />
                <div onClick={() => setShowOtpBox(!showOtpBox)} style={{ width: '100vw', height: '100vh', position: 'fixed', background: 'rgba(0,0,0,0.3)', top: 0, right: 0, left: 0, bottom: 0 }}></div>
            </>

        }
    </>
        ;
}
